/** Download rows as a CSV that opens correctly in Excel (UTF-8 BOM, ";" separator as in Argentine locale settings). */
export function downloadCsv(filename: string, rows: Array<Array<string | number>>): void {
  const cell = (v: string | number) => `"${String(v).replace(/"/g, '""')}"`;
  const body = rows.map(r => r.map(cell).join(';')).join('\r\n');
  const url = URL.createObjectURL(new Blob(['﻿' + body], { type: 'text/csv;charset=utf-8' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
